import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { McModalComponent } from './mc-modal/mc-modal.component';
import { ModalService } from './modal.service';
import { MatDialogModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
  ],
  declarations: [McModalComponent],
  entryComponents: [McModalComponent],
  exports: [McModalComponent, MatDialogModule],
  providers: [ModalService]
})
export class ModalModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/modal/modal.module.ts